export class LaunchDarklyModel {
    public feature110694addEditDeleteApplications = false;
    public feature112673administrativepagelink = false;
    public feature506985policysearch = false;
  }
export const DefaultLaunchDarklyModel = (): LaunchDarklyModel => new LaunchDarklyModel();
